<template>
  <div>
    <!-- Pillars Graph -->
    <b-row class="pillar">
      <b-col class="chart">
        <b-card class="chart">
          <h4 align="center">
            {{ $t(getTitle()) }}
          </h4>
          <b-row>
            <b-col align="center">
              <p class="card-text">
                {{ $t(getDescription()) }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col :sm="12" :lg="6">
              <div class="chart-container">
                <div class="relative-chart-size">
                  <div
                    :id="getValueAlias()"
                    style="min-height: 300px"
                    class="chart-height"
                    :style="{
                      height:
                        (chartData.length * 30 > 0
                          ? chartData.length * 30
                          : 20) + 'px',
                    }"
                  />
                </div>
              </div>
            </b-col>
            <b-col :sm="12" :lg="6">
              <b-table outlined :fields="fields" :items="formattedItems" />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- End Pillars Graph -->
  </div>
</template>
<script>
import { ChartLollipop } from "@/utils/ChartLollipop";
import * as d3 from "d3";

var cardChartCompareComponent = {
  name: "CardChartComparePillar",
  props: {
    alias: null,
    chartData: {},
    ranges: {},
    ideals: {},
    title: null,
    description: null,
  },
  data: function () {
    return {
      items: this.chartData,
      fields: [
        {
          key: "businessName",
          label: this.$t("label_organization"),
        },
        {
          key: "value",
          label: this.$t("label_reports_genderGap_indicatorValue_caption"),
        },
      ],
      indicator: {},
      indexChart: {},
      valueChart: {},
    };
  },
  computed: {
    formattedItems: function () {
      return this.getItemsFormatted();
    },
  },
  methods: {
    getItemsFormatted() {
      const itemsFormatted = [];
      if (this.items) {
        this.items.map((item) => {
          if (!isNaN(item.value)) {
            itemsFormatted.push({
              index: d3.format(".2f")(item.index),
              businessId: item.businessId,
              value: d3.format(".2f")(item.value),
              businessName: item.businessName,
            });
          } else {
            itemsFormatted.push({
              index: "N/A",
              businessId: item.businessId,
              value: "N/A",
              businessName: item.businessName,
            });
          }
        });
      }
      return itemsFormatted;
    },
    getDescription() {
      return this.description;
    },
    getTitle() {
      return this.title;
    },
    getValueAlias() {
      return `${this.alias}_value`;
    },
    getIndexAlias() {
      return `${this.alias}_index`;
    },
    createCharts() {
      this.createValueChart();
    },
    createIndexChart() {
      this.indexChart = new ChartLollipop(
        this.getIndexAlias(),
        "index",
        this.chartData
      );
      this.indexChart.render();
    },
    createValueChart() {
      this.valueChart = new ChartLollipop(
        this.getValueAlias(),
        "value",
        this.chartData,
        this.ranges,
        this.ideals,
        false
      );
      this.valueChart.render();
    },
  },
  mounted() {
    this.createCharts();
  },
};
export default cardChartCompareComponent;
</script>
<style lang="sass" scoped>
/* components/cards/CardChartCompare.vue */

@import '../../assets/css/variables.scss'
.chart-height
  min-height: 90%

@media (min-width: 900px)
  .chart-height
    min-height: 85%

@media (min-width: 1250px)
  .chart-height
    min-height: 88%

.chart-container
  width: 100%
  position: relative
  display: inline
.b-table
  font-family: $font-text
  margin-top: 1rem
  font-size: 0.8rem
  th
    text-align: center

.pillar
  text-align: center
  h4, h3
    text-transform: uppercase
    font-size: 1.3rem
    width: 100%
</style>
